import axios from "axios";
import { errorActions } from "../helpers/auth_helper";

// One row per customer (aggregated). GET /apiV1/call-intelligence/customers/
export const fetchCustomers = async (params: any) => {
  try {
    return axios
      .get(`/call-intelligence/customers/`, { params })
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching customers. Please try again.");
        return { count: 0, results: [] };
      });
  } catch (error) {
    return { count: 0, results: [] };
  }
};

// List recorded calls (paginated). Backend: GET /apiV1/call-intelligence/calls/
export const fetchCalls = async (params: any) => {
  try {
    return axios
      .get(`/call-intelligence/calls/`, { params })
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching calls. Please try again.");
        return { count: 0, results: [] };
      });
  } catch (error) {
    return { count: 0, results: [] };
  }
};

// Full detail incl. transcript + recording. GET /apiV1/call-intelligence/calls/:id/
export const fetchCallDetail = async (id: number | string) => {
  try {
    return axios
      .get(`/call-intelligence/calls/${id}/`)
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching call details. Please try again.");
        return null;
      });
  } catch (error) {
    return null;
  }
};

// Recording audio fetched through our backend (MyOperator links need a panel login).
// kind "call" → /calls/:id/recording/, "myoperator" → /myoperator-calls/:id/recording/
export const fetchRecordingBlob = async (kind: "call" | "myoperator", id: number | string): Promise<Blob> => {
  const base = kind === "call" ? "calls" : "myoperator-calls";
  const res = await axios.get(`/call-intelligence/${base}/${id}/recording/`, { responseType: "blob" });
  return res.data;
};

// All MyOperator call logs (every team). GET /apiV1/call-intelligence/myoperator-calls/
export const fetchMyOperatorCalls = async (params: any) => {
  try {
    return axios
      .get(`/call-intelligence/myoperator-calls/`, { params })
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching MyOperator calls. Please try again.");
        return { count: 0, results: [] };
      });
  } catch (error) {
    return { count: 0, results: [] };
  }
};

// QC audits (per call). GET /apiV1/call-intelligence/qc/audits/
export const fetchQCAudits = async (params: any) => {
  try {
    return axios
      .get(`/call-intelligence/qc/audits/`, { params })
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching QC audits. Please try again.");
        return { count: 0, results: [] };
      });
  } catch (error) {
    return { count: 0, results: [] };
  }
};

// Full QC audit incl. per-metric breakdown + transcript. /qc/audits/:id/
export const fetchQCAuditDetail = async (id: number | string) => {
  try {
    return axios
      .get(`/call-intelligence/qc/audits/${id}/`)
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching QC audit. Please try again.");
        return null;
      });
  } catch (error) {
    return null;
  }
};

// Per-agent QC scorecard rollup. GET /apiV1/call-intelligence/qc/agents/
export const fetchQCAgents = async (params: any) => {
  try {
    return axios
      .get(`/call-intelligence/qc/agents/`, { params })
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching QC agents. Please try again.");
        return { count: 0, results: [] };
      });
  } catch (error) {
    return { count: 0, results: [] };
  }
};

// Fail rate per rubric metric across the filtered audits. GET /apiV1/call-intelligence/qc/metrics/
export const fetchQCMetrics = async (params: any) => {
  try {
    return axios
      .get(`/call-intelligence/qc/metrics/`, { params })
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching QC metric breakdown. Please try again.");
        return { results: [] };
      });
  } catch (error) {
    return { results: [] };
  }
};

// Customer Intelligence list (one row per customer, flag + KPIs).
// GET /apiV1/call-intelligence/customer-intelligence/
export const fetchCustomerIntelligence = async (params: any) => {
  try {
    return axios
      .get(`/call-intelligence/customer-intelligence/`, { params })
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching customers. Please try again.");
        return { count: 0, results: [], kpis: null };
      });
  } catch (error) {
    return { count: 0, results: [], kpis: null };
  }
};

// One customer's profile: orders, tickets, calls, overall summary, flag.
// GET /apiV1/call-intelligence/customer-intelligence/:userId/
export const fetchCustomerProfile = async (userId: string) => {
  try {
    return axios
      .get(`/call-intelligence/customer-intelligence/${userId}/`)
      .then((res) => res.data)
      .catch((error) => {
        errorActions(error, "Error fetching the customer profile. Please try again.");
        return null;
      });
  } catch (error) {
    return null;
  }
};
